import React, { useEffect } from 'react'
import { Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle';
import Wrapper from '../../dashboardWrapper/Wrapper'
import DashAdminHalls from './ADMIN/halls/DashAdminHalls';
import AdminHeader from './ADMIN/header/AdminHeader';
import DashAdminCoCategories from './ADMIN_CO/categories/DashAdminCoCategories';
import AdminCoHeader from './ADMIN_CO/header/AdminCoHeader';
import DashDeveloperHalls from './DEVELOPER/halls/DashDeveloperHalls';
import DeveloperHeader from './DEVELOPER/header/DeveloperHeader';
import { useDispatch, useSelector } from 'react-redux'
import './style.scss'
import { fetchCheckLogin } from '../../../redux/action/login/checkLogin';
import DashboardScreenLoading from '../../../utils/DashboardScreenLoading';
import DashboardContent from '../../dashboardWrapper/DashboardContent';

const Dashboard = () => {
    let userdata = JSON.parse(localStorage.getItem("user"))
    const login = useSelector(state => state.login)
    const {t} = useTranslation();
    const dispatch = useDispatch()
    
    useEffect(() => {
        dispatch(fetchCheckLogin())
    }, [])

    if(login.loading) {
        return <DashboardScreenLoading />
    } else {
        if(userdata) {
            if(userdata.role === "DEVELOPER") {
                return (
                    <Wrapper>
                        <DashboardContent>
                            <DashboardMainTitle> {t("dashboard_nav_dashboard")} </DashboardMainTitle>
                            <div className="col-12 mb-5">
                                <DeveloperHeader />
                            </div>
                            <Row>
                                <div className="col-md-12 mt-3">
                                    <div className="halls">
                                        <DashDeveloperHalls />
                                    </div>
                                </div>
                            </Row>
                        </DashboardContent>
                    </Wrapper>
                )
            } else if (userdata.role === "ADMIN") {
                return (
                    <Wrapper>
                        <DashboardContent>
                            <DashboardMainTitle> {t("dashboard_nav_dashboard")} </DashboardMainTitle>
                            <div className="col-12 mb-5">
                                <AdminHeader />
                            </div>
                            <Row>
                                <div className="col-md-12 mt-3">
                                    <div className="halls">
                                        <DashAdminHalls />
                                    </div>
                                </div>
                            </Row>
                        </DashboardContent>
                    </Wrapper>
                )
            } else {
                return (
                    <Wrapper>
                        <DashboardContent>
                            <DashboardMainTitle> {t("dashboard_nav_dashboard")} </DashboardMainTitle>
                            <div className="col-12 mb-5">
                                <AdminCoHeader />
                            </div>
                            <Row className="my-5">
                                <div className="col-md-12">
                                    <div className="rooms">
                                        <DashAdminCoCategories />
                                    </div>
                                </div>
                            </Row>
                        </DashboardContent>
                    </Wrapper>
                )
            }
        } else {
            return <Redirect to="/login" />
        }
    }
}

export default Dashboard
